export default "__VITE_ASSET__tjeFEQvz__"